import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import validationMessages from 'vee-validate/dist/locale/en';
import customRules from './vee-validate-rules';

Vue.use(VueI18n);

const i18n = new VueI18n();
i18n.locale = 'en'; // set a default locale (without it, it won't work).

Vue.use(VeeValidate, {
    i18nRootKey: 'validations', // customize the root path for validation messages.
    i18n,
    dictionary: {
        en: validationMessages
    },
    events: 'blur'
});

Object.keys(customRules).forEach(name => {
    VeeValidate.Validator.extend(name, customRules[name]);
});
